import * as types from './action-types';

let id = 0;

export const showMessage = message => {
  return dispatch => {
    if(typeof(message) === 'string')
      message = {text: message, duration: 2000};
    message = {...message, id: id++};
    if(message.duration) {
      setTimeout(() => {
        dispatch(hideMessage(message));
      }, message.duration);
    }
    dispatch({
      type: types.showMessage,
      message
    })
  }
}

export const hideMessage = message => ({
  type: types.hideMessage,
  message
})



// WEBPACK FOOTER //
// ./src/actions/message-actions.js